function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDel18 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z",
  "data-name": "Rectangle 118",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 16",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 5.624.624 10 0 9.375 4.376 5 0 .624.624 0 5 4.376 9.376 0 10 .624 5.624 5 10 9.376 9.376 10z",
  style: {
    stroke: "none"
  },
  transform: "translate(4 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.376 10 5 5.624.624 10 0 9.375 4.376 5 .001.624.624 0 5 4.376 9.376 0 10 .624 5.624 5 10 9.376z",
  style: {
    fill: "#7b7b7b",
    stroke: "none"
  },
  transform: "translate(4 4)"
})));
export default SvgIconDel18;